import { Routes } from '@angular/router';

export const routes: Routes = [
    // { path: '', redirectTo: '/', pathMatch: 'full' },
      {
        path: '',
        loadChildren: () =>
          import('./genesys/genesys.module').then(
            (m) => m.GenesysModule
          ),
      }
];
